/**
 * Support messages.
 *
 * `POST /feedback` takes optional authentication, so the contact form works for
 * a signed-out visitor on the landing page and attaches the account when there
 * is one. The transport adds the bearer token whenever a session exists, which
 * is exactly the behaviour that endpoint expects.
 */

import { api } from "../api";
import type { CreateFeedbackRequest, Feedback } from "../types";

export const feedbackApi = api.injectEndpoints({
    endpoints: (build) => ({
        submitFeedback: build.mutation<Feedback, CreateFeedbackRequest>({
            query: (body) => ({ url: "feedback", method: "POST", body }),
        }),
    }),
});

export const { useSubmitFeedbackMutation } = feedbackApi;
